module.exports = __webpack_public_path__ + "static/contentselection-edgeplacement-do-323baf71436fb17f5844aeffa39314fa.png";